import { render, staticRenderFns } from "./Facetracker.vue?vue&type=template&id=683a4bc7&"
import script from "./Facetracker.vue?vue&type=script&lang=js&"
export * from "./Facetracker.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports